import { useState, useEffect, useContext, useRef } from 'react';

import PracticeReserveDatetimeModalTime from './time/PracticeReserveDatetimeModalTime';
import { formatDate } from '../../../../../../../util/utility';


function PracticeReserveDatetimeModalDate(props: any) {

  const dateKey = props.dateKey;
  const dateInfo = props.dateInfo;

  const openDateKey = props.openDateKey;
  const setOpenDateKey = props.setOpenDateKey;
  const dateRef = props.dateRef;

  const chgOpenDate = () => {
    if(openDateKey == dateKey) {
      // 開いている場合→閉じる
      setOpenDateKey('');
    } else {
      // 閉じている場合→開く
      setOpenDateKey(dateKey);
    }
  }


  return (
    <div ref={dateRef} key={dateKey}>
      <div
        className="list-group-item list-group-item-info"
        style={{ cursor: 'pointer' }}
        onClick={chgOpenDate}
      >
        <strong>{formatDate(dateKey)}</strong>
        <span className="glyphicon glyphicon-chevron-down pull-right"></span>
      </div>

      {openDateKey == dateKey &&
        <div id={`c_${dateKey}`} className="sublinks">
          <ul className="list-group" style={{ marginBottom: '2px' }}>
            {Object.entries(dateInfo).map(([timeKey, timeInfo]: [string, any]) =>
              timeInfo && (
                <>
                  {/* 時間一覧 */}
                  <PracticeReserveDatetimeModalTime
                    dateKey={dateKey}
                    timeKey={timeKey}
                    timeInfo={timeInfo}
                  />
                </>
              )
            )}
          </ul>
        </div>
      }
    </div>
  );
}
  
export default PracticeReserveDatetimeModalDate;